

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {EOrderPaymentStatuses, EOrderTypes, IOrder} from "@/model/Order/orderInterfaces";
import {IChipStyle, IChipStyles} from "@/model/chipStyleInterfaces";

@Component({})
export default class PaymentStatusChip extends Vue {

  @Prop()
  protected order!: IOrder;

  private static readonly chipStyles: IChipStyles = {
    status_payment_unpaid: {
      icon: 'mdi-cash',
      color: 'secondary',
    },
    status_payment_paid: {
      icon: 'mdi-cash',
      color: 'success',
    },
    status_payment_declined: {
      icon: 'mdi-cash',
      color: 'alert',
    },
    status_payment_unpaid_invoice: {
      icon: 'mdi-checkbook',
      color: 'secondary',
    },
    status_payment_paid_invoice: {
      icon: 'mdi-checkbook',
      color: 'success',
    },
    notConfirmed: {
      icon: 'mdi-alert-decagram',
      color: 'red',
    }
  }

  protected get showPayStatus(): boolean {
    return this.order.type !== EOrderTypes.delivery_with_code;
  }

  protected get maskedStatus(): string {
    const paidStatuses: string[] = [
      EOrderPaymentStatuses.status_payment_paid,
      EOrderPaymentStatuses.status_payment_paid_invoice,
    ];
    // if paid, always show paid. if not paid, and not locked, show only awaiting confirmation (from BAO)
    return paidStatuses.includes(this.order.payment_status) || this.order.locked
        ? this.order.payment_status
        : 'notConfirmed';
  }

  protected get chipStyle(): IChipStyle {
    return PaymentStatusChip.chipStyles[this.maskedStatus] || {};
  }

  protected get statusText(): string {
    return 'orders.order.paymentStatuses.' + this.maskedStatus;
  }

}

